import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

const LOCAL_STORAGE_KEY = 'route-history-store';

export interface RouteState {
  previousRoute: string | null;
  routeHistory: string[];
  addToHistory: (route: string) => void;
  clearHistory: () => void;
}

export const usePreviousRouteStore = create<RouteState>()(
  persist(
    (set, get) => ({
      previousRoute: null,
      routeHistory: [],

      addToHistory: (route: string) => {
        const { routeHistory } = get();

        if (route !== routeHistory[routeHistory.length - 1]) {
          const newHistory = [...routeHistory, route];
          set({
            routeHistory: newHistory,
            previousRoute: newHistory[newHistory.length - 2] || null,
          });
        }
      },

      clearHistory: () => set({ previousRoute: null, routeHistory: [] }),
    }),
    {
      name: LOCAL_STORAGE_KEY,
      storage: createJSONStorage(() => globalThis.localStorage),
    },
  ),
);
